"use strict";
/* eslint-disable
    zillow/@typescript-eslint/naming-convention,
    zillow/@typescript-eslint/no-unsafe-assignment,
    max-classes-per-file
*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = exports.getDocument = void 0;
const react_1 = __importDefault(require("react"));
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const document_1 = __importStar(require("next/document"));
const styled_components_1 = require("styled-components");
const page_frame_next_utils_1 = require("@zillow/page-frame-next-utils");
const PageFrameBody_1 = require("./PageFrameBody");
/**
 * Generate a customized _document subclass.
 * @param {object} [options]
 * @param {string} [options.bodyClassName]
 * @param {string[]} [options.components]
 * @param {boolean} [options.styledComponents]
 * @param {boolean} [options.regionalizedLinks]
 * @param {string} [options.gaTrackingId]
 * @param {boolean} [options.includeZsg]
 * @param {boolean} [options.deferDropdowns]
 * @param {any} [options.beforeTopNav] A component to be rendered before the top nav content
 * @param {string} [options.headerVersion]
 * @param {boolean} [options.mobileAppCheck]
 * @param {boolean} [options.includeComscore]
 * @param {boolean} [options.includeGTM]
 * @param {boolean} [options.staticMarkup]
 */
function getDocument({ beforeTopNav, bodyClassName, staticMarkup, components, deferDropdowns, gaTrackingId, headerVersion, includeComscore, includeGTM, includeZsg, mobileAppCheck, pfsHost, regionalizedLinks, requestHeaders, s3sHost, styledComponents, } = {}) {
    class PageFrameDoc extends document_1.default {
        static async getInitialProps(ctx) {
            var _a;
            let sheet;
            if (styledComponents) {
                const originalRenderPage = ctx.renderPage;
                sheet = new styled_components_1.ServerStyleSheet();
                ctx.renderPage = () => originalRenderPage({
                    enhanceApp: (App) => (props) => sheet ? sheet.collectStyles(react_1.default.createElement(App, { ...props })) : null,
                });
            }
            const deferDropdownsOption = ((_a = ctx.pageFrameOverrides) === null || _a === void 0 ? void 0 : _a.deferDropdowns) != null
                ? ctx.pageFrameOverrides.deferDropdowns
                : deferDropdowns;
            // CMS-2637 Hide header if fromApp is present in query
            const { fromApp = false } = ctx.query;
            let componentsOption;
            componentsOption = components !== null && components !== void 0 ? components : ['headTags', 'topnav', 'footer', 'bodyScripts', 'reg'];
            if (mobileAppCheck && fromApp) {
                componentsOption = componentsOption.filter((component) => component !== 'topnav');
            }
            const [pageFrameData, initialProps] = await Promise.all([
                (0, page_frame_next_utils_1.getDocumentData)(ctx, {
                    pfsHost,
                    s3sHost,
                    regionalizedLinks,
                    gaTrackingId,
                    includeZsg,
                    deferDropdowns: deferDropdownsOption,
                    headerVersion,
                    requestHeaders,
                    includeComscore,
                    includeGTM,
                    staticMarkup,
                }),
                document_1.default.getInitialProps(ctx),
            ]);
            // wrap this in a try finally so we can terminate styled-components through sheet.seal()
            // and prevent a memory leak
            try {
                let styles;
                if (Array.isArray(initialProps.styles)) {
                    styles = [...initialProps.styles, ...(sheet ? sheet.getStyleElement() : [])];
                }
                else {
                    styles = [...(sheet ? sheet.getStyleElement() : [])];
                }
                return {
                    ...initialProps,
                    bodyClassName,
                    components: componentsOption,
                    pageFrameData,
                    beforeTopNav,
                    styles,
                };
            }
            finally {
                if (styledComponents && sheet && typeof sheet.seal === 'function') {
                    sheet.seal();
                }
            }
        }
        render() {
            return (react_1.default.createElement(document_1.Html, { lang: "en", itemScope: true, itemType: "http://schema.org/Organization", 
                /* @ts-expect-error This is a valid html attribute which isn't in the react props for some reason */
                xmlns: "http://www.w3.org/1999/xhtml" },
                react_1.default.createElement(PageFrameBody_1.PageFrameBody, { className: this.props.bodyClassName, pageFrameData: this.props.pageFrameData, components: this.props.components, beforeTopNav: this.props.beforeTopNav },
                    react_1.default.createElement(document_1.Main, null),
                    react_1.default.createElement(document_1.NextScript, null))));
        }
    }
    (0, hoist_non_react_statics_1.default)(PageFrameDoc, document_1.default, {
        getInitialProps: true,
    });
    return PageFrameDoc;
}
exports.getDocument = getDocument;
// Export default page frame document
exports.Document = getDocument();
